const firebaseConfig = {
  apiKey: "AIzaSyDcXNMfqobPfd7GutGJJYCCQWmEShcMNWs",
  authDomain: "creative-agency-368ac.firebaseapp.com",
  databaseURL: "https://creative-agency-368ac.firebaseio.com",
  projectId: "creative-agency-368ac",
  storageBucket: "creative-agency-368ac.appspot.com",
  messagingSenderId: "1085589179091",
  appId: "1:1085589179091:web:7a0002cf838ce99386e226",
};

export default firebaseConfig;
